// AD-10 (amended 2026-09-23): mirrors apps/api/src/serviceStatus.ts. A line is pre-service when
// its property's placedInServiceDate is null (or absent) or strictly later than the payment date.
// The API sends an ISO timestamp; only its UTC calendar day is compared, as text — never parsed
// into a local Date, which would slip a day in a US timezone.
export function isPreService(
  placedInServiceDate: string | null | undefined,
  paymentDate: string
): boolean {
  if (placedInServiceDate == null) return true;
  return placedInServiceDate.slice(0, 10) > paymentDate;
}
